import { Link } from '@hub/link'
import { Logo } from '@hub/logos'
import React, { useContext } from 'react'
import { HubStyleObject } from '@hub/design-system-base'
import { LinkContext } from '../../../context'
import analyticsUtils from '../../../helpers/analytics-utils'
import trackEvent from '../../../helpers/analytics-utils/track-event'
interface UniversalHeaderLogosProps {
  logo?: React.ComponentProps<typeof Logo>['variant']
  mono?: React.ComponentProps<typeof Logo>['mono']
  boxSize?: React.ComponentProps<typeof Logo>['boxSize']
  sx?: HubStyleObject
  url?: string
}

export const UniversalHeaderLogos: React.FC<UniversalHeaderLogosProps> = ({
  logo,
  mono,
  boxSize,
  sx,
  url = '/',
}) => {
  const RouterLink = useContext(LinkContext)

  return (
    <Link
      as={props => <RouterLink to={url} {...props} />}
      href={url}
      sx={sx}
      onClick={() =>
        trackEvent(
          analyticsUtils.categories.UNIVERSAL_HEADER,
          analyticsUtils.actions.UNIVERSAL_HEADER_NAV_LINK_CLICK,
          analyticsUtils.labels.createLogoLabel(logo)
        )
      }
    >
      <Logo variant={logo} mono={mono} boxSize={boxSize} />
    </Link>
  )
}
